// $(document).on('click', '#skip-upload', function() {
//         $('.ctm-product-form__submit').trigger('click'); 
//         $('.close_btn').trigger('click');
        
// });
document.getElementById('skip-upload').addEventListener('click', function() {
    if (!document.cookie.split('; ').find(row => row.startsWith('skipUpload='))) {
        console.log('JavaScript is running for the first time.');
        $('.ctm-product-form__submit').trigger('click'); 
        $('.close_btn').trigger('click');
         $('.close_btn_').trigger('click');
        document.cookie = "skipUpload=true; path=/; max-age=31536000"; // 1 year expiry
    } else {
        console.log('The JavaScript has already been executed.');
       $('.popup-container-1').css({
            'visibility': 'hidden',
            'opacity': '0',
            // 'transition': 'all 0.1s',
            'transform': 'scale(1.3)',
            'position': 'fixed'
        });
      $('.section-header.shopify-section-group-header-group').css({
                        'z-index': '3'
                    });
         $('body').css({
                        'overflow': 'auto'
                    });
      $('.ctm-product-form__submit').show(); 
       $('.ctm-add-to-cart-btn').hide(); 
       $('.ctm-product-form__submit').trigger('click'); 
    }
});
function removeSkipUploadCookie() {
    document.cookie = "skipUpload=; path=/; max-age=0"; // Expire the cookie immediately
}
$(document).on('click', '#upload-button_', function() {
        $('.close_btn_').trigger('click');
        $('#upload-file').trigger('click');
        
});
// js for color swaches
// money format
// Mandasa custom js

var checkedTitle = $('input[name="bundle_product"]:checked').val();
const checkedRadioButton = document.querySelector('input[name="bundle_product"]:checked');
    if (checkedRadioButton) {
      const selectedVarValue = checkedRadioButton.getAttribute('selected_var');
      const selected_varprice = checkedRadioButton.getAttribute('data_price');
      console.log('Selected Var Value:', selectedVarValue);
      $(".product_list .option_name_heading .data-price").text(selected_varprice);
    }
$(".product_list .form__label .data-title").text(checkedTitle);


 $('input[name="bundle_product"]').on('change', function () {
    var selectedTitle = $(this).val();
    var data_symbol = $(this).attr('data_symbol'); 
    var data_code = $(this).attr('data_code'); 
    var main_product_id = $(this).closest(".product__info-container").find("#hidden-product-id").val();
    console.log(main_product_id);
      
    var selectedVariantPrice = $(".variant-price[data-variant-id='" + main_product_id + "']").val();
    var selectedVariantCoPrice = $(".variant-price[data-variant-id='" + main_product_id + "']").attr("compare_at_price");

    if (selectedVariantPrice) {
        console.log("Price:", selectedVariantPrice);
    }

    const selected_varp = $(this).attr('data_price');
    const selected_var_id = $(this).attr('selected_var');
    var selected_price = (selected_varp / 100).toFixed(2);

    const checkedRadioButton_first = document.querySelector('input[name="bundle_product_second"]:checked');
    const selected_varprice_first = checkedRadioButton_first?.getAttribute('data_price') || 0;
    const selected_varCprice_first = checkedRadioButton_first?.getAttribute('data_co_price') || 0;

    const checkedRadioButton_sec = document.querySelector('input[name="bundle_product_third"]:checked');
    const selected_varprice_sec = checkedRadioButton_sec?.getAttribute('data_price') || 0;
    const selected_varCprice_sec = checkedRadioButton_sec?.getAttribute('data_co_price') || 0;

    var selected_varcp = $(this).attr('data_co_price');
    var selected_co_price = (selected_varcp / 100).toFixed(2);

    console.log("selectedVariantCoPrice:", selectedVariantCoPrice);
    console.log("selected_varcp:", selected_varcp);
    console.log("selected_varCprice_first:", selected_varCprice_first);
    console.log("selected_varCprice_sec:", selected_varCprice_sec);

    function toFloat(value) {
        return parseFloat((value || "0").toString().replace(/[^0-9.\-]/g, "")) || 0;
    }

    var total_c_Price = 
        toFloat(selectedVariantCoPrice) + 
        toFloat(selected_varcp) + 
        toFloat(selected_varCprice_first) + 
        toFloat(selected_varCprice_sec);
    
    let updated_c_price = (total_c_Price / 100).toFixed(2);
    console.log(total_c_Price, "aaa");

     $(".compare_at_price_ctm").html( updated_c_price + data_symbol);
    updateDiscountBadge();
   
    if (selectedVariantPrice && selected_varp) { 
        var totalPrice = parseFloat(selectedVariantPrice) + parseFloat(selected_varprice_sec) + parseFloat(selected_varprice_first) + parseFloat(selected_varp);
        let updated_price = (totalPrice / 100).toFixed(2);
        console.log("Total Price:", data_symbol + ' ' + updated_price);
        $(".price_total").html( updated_price +  data_symbol );
       updateDiscountBadge();
    } else {
        console.log("Missing price data for calculation.");
    }

    $(this).closest(".product_list").find('.form__label .data-title').text(selectedTitle);
   $(this).closest(".product_list").find(".option_name_heading .data-price").html( selected_price + data_symbol );

    console.log(selected_var_id);
});

$('input[name="bundle_product_second"]').on('change', function () {
    var selectedTitle = $(this).val();
    var data_symbol = $(this).attr('data_symbol'); 
    var data_code = $(this).attr('data_code'); 
    var main_product_id = $(this).closest(".product__info-container").find("#hidden-product-id").val();
    var selectedVariantCoPrice = $(".variant-price[data-variant-id='" + main_product_id + "']").attr("compare_at_price");
    var selectedVariantPrice = $(".variant-price[data-variant-id='" + main_product_id + "']").val();
    if (selectedVariantPrice) {
        console.log("Price:", selectedVariantPrice);
    }

    const selected_varp = $(this).attr('data_price');
    const selected_var_id = $(this).attr('selected_var');
    var selected_price = (selected_varp / 100).toFixed(2);

    const checkedRadioButton_fi = document.querySelector('input[name="bundle_product"]:checked');
    const selected_varprice_fi = checkedRadioButton_fi?.getAttribute('data_price') || 0;
    const selected_varCprice_first = checkedRadioButton_fi?.getAttribute('data_co_price') || 0;

    // Declare variables outside the if block
    let selected_varprice_s = 0;
    let selected_varCprice_sec = 0;

    const checkedRadioButton_s = document.querySelector('input[name="bundle_product_third"]:checked');
    if (checkedRadioButton_s) { 
        selected_varprice_s = checkedRadioButton_s.getAttribute('data_price') || 0;
        selected_varCprice_sec = checkedRadioButton_s.getAttribute('data_co_price') || 0;
    }

    var selected_varcp = $(this).attr('data_co_price');
    var selected_co_price = (selected_varcp / 100).toFixed(2);

    console.log(selected_co_price + " fdf " + selected_varCprice_first + " dd " + selected_varCprice_sec);

    var totalPrice_compare = parseFloat(selected_varcp) + parseFloat(selectedVariantCoPrice) + parseFloat(selected_varCprice_first) + parseFloat(selected_varCprice_sec);
    let updated_c_price = (totalPrice_compare / 100).toFixed(2);
    console.log(updated_c_price, "checkifff");
    $(".compare_at_price_ctm").html( updated_c_price + data_symbol);
    updateDiscountBadge();
  
    if (selectedVariantPrice && selected_varp) { 
        var totalPrice = parseFloat(selectedVariantPrice) +  parseFloat(selected_varprice_fi) +  parseFloat(selected_varprice_s)  + parseFloat(selected_varp);
        let updated_price = (totalPrice / 100).toFixed(2);
        console.log("Total Price:", data_symbol + ' ' + updated_price);
        $(".price_total").html( updated_price +  data_symbol );
      updateDiscountBadge();
    } else {
        console.log("Missing price data for calculation.");
    }

    $(this).closest(".product_list").find('.form__label .data-title').text(selectedTitle);
    $(this).closest(".product_list").find(".option_name_heading .data-price").html( selected_price + data_symbol );

    console.log(selected_var_id);
});

$('input[name="bundle_product_third"]').on('change', function () {
    var selectedTitle = $(this).val();
    var data_symbol = $(this).attr('data_symbol'); 
    var data_code = $(this).attr('data_code'); 
    var main_product_id = $(this).closest(".product__info-container").find("#hidden-product-id").val();
    console.log(main_product_id);

    var selectedVariantPrice = $(".variant-price[data-variant-id='" + main_product_id + "']").val();
    var selectedVariantCoPrice = $(".variant-price[data-variant-id='" + main_product_id + "']").attr("compare_at_price");

    if (selectedVariantPrice) {
        console.log("Price:", selectedVariantPrice);
    }

    const selected_varp = $(this).attr('data_price');
    const selected_var_id = $(this).attr('selected_var');
    var selected_price = (selected_varp / 100).toFixed(2);

    const checkedRadioButton_th = document.querySelector('input[name="bundle_product"]:checked');
    const selected_varprice_th = checkedRadioButton_th?.getAttribute('data_price') || 0;
    const selected_varCprice_first = checkedRadioButton_th?.getAttribute('data_co_price') || 0;

    const checkedRadioButton_sth = document.querySelector('input[name="bundle_product_second"]:checked');
    const selected_varprice_sth = checkedRadioButton_sth?.getAttribute('data_price') || 0;
    const selected_varCprice_sec = checkedRadioButton_sth?.getAttribute('data_co_price') || 0;

    var selected_varcp = $(this).attr('data_co_price');
    var selected_co_price = (selected_varcp / 100).toFixed(2);

    function toFloat(value) {
        return parseFloat((value || "0").toString().replace(/[^0-9.\-]/g, "")) || 0;
    }

    console.log("selected_co_price:", selected_co_price);
    console.log("selected_varCprice_first:", selected_varCprice_first);
    console.log("selected_varCprice_sec:", selected_varCprice_sec);

    var totalPrice_compare = 
        toFloat(selected_varcp) + 
        toFloat(selectedVariantCoPrice) + 
        toFloat(selected_varCprice_first) + 
        toFloat(selected_varCprice_sec);

    let updated_c_price = (totalPrice_compare / 100).toFixed(2);
    console.log(updated_c_price, "checkifff");
     $(".compare_at_price_ctm").html( updated_c_price + data_symbol);
    updateDiscountBadge();
  
    if (selectedVariantPrice && selected_varp) {
        var totalPrice = 
            parseFloat(selectedVariantPrice) + 
            parseFloat(selected_varprice_th) + 
            parseFloat(selected_varprice_sth) + 
            parseFloat(selected_varp);

        let updated_price = (totalPrice / 100).toFixed(2);
        console.log("Total Price:", data_symbol + ' ' + updated_price);
        $(".price_total").html( updated_price +  data_symbol );
      updateDiscountBadge();
    } else {
        console.log("Missing price data for calculation.");
    }

    $(this).closest(".product_list").find('.form__label .data-title').text(selectedTitle);
    $(this).closest(".product_list").find(".option_name_heading .data-price").html(data_symbol + selected_price);

    console.log(selected_var_id);
});

function updateDiscountBadge() {
  let priceText = $(".price_total").text().replace(/[^\d.,]/g, '').replace(',', '.');
  let compareText = $(".compare_at_price_ctm").text().replace(/[^\d.,]/g, '').replace(',', '.');

  let price = parseFloat(priceText);
  let compare = parseFloat(compareText);

  if (!isNaN(price) && !isNaN(compare) && compare > price) {
    let discount = Math.round(((compare - price) / compare) * 100);
    $(".kav_price__badge-sale").html("Économisez " + discount + "%").show();
  } else {
    $(".kav_price__badge-sale").hide();
  }
}

$(document).ready(function () {
    $('input[name="bundle_product"]:checked').trigger('change');
    $('input[name="bundle_product_second"]:checked').trigger('change');
    $('input[name="bundle_product_third"]:checked').trigger('change');
});

 var inputNameoption = 'options[' + optionLabelNamectm + ']';
  $(document).on('change', 'input[name="' + inputNameoption + '"]', function () {
    
  let selectedValue = $(this).val();
     let $this = $(this);
   var main_product_id = $(this).closest(".product__info-container").find("#hidden-product-id").val();
   var selectedVariantPrice = $(".variant-price[data-variant-id='" + main_product_id + "']").val();
   let selectedVariantPrice_ = parseFloat((selectedVariantPrice / 100).toFixed(2));
    let data_symbol = $this.data('symbol');
    let data_code = $this.data('code');
    console.log(data_symbol, "selectedVariantPrice:", selectedVariantPrice_, data_code);
    $(this).closest("variant-selects").find(".data-price").html( selectedVariantPrice_ + data_symbol );
  // console.log('Selected Type:', selectedValue);
  // var all_html = $(".hide_mt").html();
  // $(".my-gallery .thumbnail-list__item").remove();
  $( ".my-gallery .thumbnail-list__item").each(function() {
        var our_ddvar = $(this).clone(); 
        // console.log(our_ddvar);
        var var_el3 = $(this).attr('data-alt');
          // console.log(var_el3);
         if(selectedValue == var_el3) {
           $(this).addClass('showing_images');
           // $(".my_gallery").append(our_ddvar);
           // $(our_ddvar).appendTo('.my-gallery');
           // $(".product-single__photo").show();
         }else{
            $(this).removeClass('showing_images');
         }
      });
    updateDiscountBadge();
});


  $(document).ready(function () {
    var inputName = 'options[' + optionLabelNamectm + ']';
    var $selectedInput = $('input[name="' + inputName + '"]:checked');
    console.log("inputName", inputName);
    
  var selectedValue = $selectedInput.val();
  if ($selectedInput.length > 0) {
    var $container = $(".product__info-container");
    var main_product_id = $container.find("#hidden-product-id").val();
    var selectedVariantPrice = $(".variant-price[data-variant-id='" + main_product_id + "']").val();
    let selectedVariantPrice_ = parseFloat((selectedVariantPrice / 100).toFixed(2));
    let data_symbol = $selectedInput.data('symbol');
    let data_code = $selectedInput.data('code');
    console.log(data_symbol, "selectedVariantPrice:", selectedVariantPrice_, data_code);
    $container.find(".option_name_type .data-price").html( selectedVariantPrice_ + data_symbol);
    $(".my-gallery .thumbnail-list__item").each(function (index) {
      var $thumb = $(this);
      var var_el3 = $thumb.attr('data-alt');

      if (var_el3 === '') {
        $thumb.addClass('showing_images');
      } else if (selectedValue === var_el3) {
        $thumb.addClass('showing_images');
      }
    });
      updateDiscountBadge();
  } else {
    console.warn("No Bracelet option is selected.");
  }
});
